module.exports = __webpack_public_path__ + "static/media/frown-open.e76a9437.svg";